import { Component, Input, OnInit } from '@angular/core';
import { AbstractComponent } from "@components";
import {
  Country,
  EventItem, FetchEventByIdRequest, Lookups, Race, WspayConfirmation,
  PaymentStatus
} from "@model";
import { EventItemType } from 'src/app/model/event-item-type';
import { DatePipe } from '@angular/common';
import { EventService } from '@services';

@Component({
  selector: 'app-event-list-item',
  templateUrl: './event-list-item.component.html',
  styleUrls: ['./event-list-item.component.scss'],
  providers: [DatePipe]
})
export class EventListItemComponent extends AbstractComponent implements OnInit {
  @Input() eventItemType: EventItemType | undefined;
  @Input() isFinishedEvent: boolean = false;
  @Input() wspayConfirmation: WspayConfirmation | undefined;
  @Input() race: Race | undefined;
  @Input({ required: true }) languages: Lookups[] = [];
  @Input() countries: Lookups[] = [];
  country: string | undefined;
  eventItem: EventItem | undefined;
  protected readonly WsPaymentStatus = PaymentStatus;

  constructor(private datePipe: DatePipe, private eventService: EventService) {
    super();
  }

  ngOnInit(): void {
    this.getCountryName(this.race?.startCountry);
  }


  checkSameDate(race: Race | undefined) {
    if (race?.raceStart && race?.raceEnd) {
      let startDate: Date = new Date(race.raceStart);
      let endDate: Date = new Date(race.raceEnd);
      return (startDate < endDate) && (startDate.getDate() !== endDate.getDate());
    } else {
      return false;
    }
  }

  validCityAndCountry(country: string | undefined, city: string | undefined): string {
    if (country && city) {
      return city + ", " + country;
    } else if (country) {
      return country;
    } else if (city) {
      return city;
    }
    return '-';
  }


  formatDate(date: Date | string): string {
    const month = this.datePipe.transform(date, 'MMM');
    return month ? month.slice(0, 3) : '';
  }

  getCountryName(countryCode: number | undefined) {
    this.countries?.find((country: Country) => {
      if (countryCode === country.id) {
        this.country = country?.shortCode;
      }
    });
  }
}
